import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

const MatiereService = {
  // Récupérer toutes les matières
  async getAllMatieres() {
    try {
      const result = await axios.get(`${apiUrl}/matieres`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans getAllMatieres:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des matières",
        data: []
      };
    }
  },

  // Récupérer une matière par ID
  async getMatiereById(id) {
    try {
      const result = await axios.get(`${apiUrl}/matieres/${id}`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans getMatiereById:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération de la matière",
        data: null
      };
    }
  },

  // Créer une matière
  async createMatiere(data) {
    try {
      const result = await axios.post(`${apiUrl}/matieres/create`, data);
      return result.data;
    } catch (error) {
      console.error("Erreur dans createMatiere:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la création de la matière",
        data: null
      };
    }
  },

  // Mettre à jour une matière
  async updateMatiere(id, data) {
    try {
      const result = await axios.put(`${apiUrl}/matieres/update/${id}`, data);
      return result.data;
    } catch (error) {
      console.error("Erreur dans updateMatiere:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la mise à jour de la matière",
        data: null
      };
    }
  },

  // Supprimer une matière
  async deleteMatiere(id) {
    try {
      const result = await axios.delete(`${apiUrl}/matieres/delete/${id}`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans deleteMatiere:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la suppression de la matière",
        data: null
      };
    }
  },

  // Récupérer les classes d'une matière
  async getMatiereClasses(matiereId) {
    try {
      const result = await axios.get(`${apiUrl}/matieres/${matiereId}/classes`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans getMatiereClasses:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la récupération des classes",
        data: []
      };
    }
  },

  // Synchroniser les classes d'une matière (remplace toutes les associations)
  async syncMatiereClasses(matiereId, classeIds) {
    try {
      const result = await axios.put(`${apiUrl}/matieres/${matiereId}/classes`, { classe_ids: classeIds });
      return result.data;
    } catch (error) {
      console.error("Erreur dans syncMatiereClasses:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de la synchronisation des classes",
        data: null
      };
    }
  },

  // Ajouter une classe à une matière
  async addClasseToMatiere(matiereId, classeId) {
    try {
      const result = await axios.post(`${apiUrl}/matieres/add_classe/${matiereId}/classes`, { classe_id: classeId });
      return result.data;
    } catch (error) {
      console.error("Erreur dans addClasseToMatiere:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors de l'ajout de la classe",
        data: null
      };
    }
  },

  // Retirer une classe d'une matière
  async removeClasseFromMatiere(matiereId, classeId) {
    try {
      const result = await axios.delete(`${apiUrl}/matieres/removeclasse/${matiereId}/classes/${classeId}`);
      return result.data;
    } catch (error) {
      console.error("Erreur dans removeClasseFromMatiere:", error);
      return {
        status: false,
        message: error.response?.data?.message || "Erreur lors du retrait de la classe",
        data: null
      };
    }
  }
};

export default MatiereService;